/**
 * A JSON:API resource.
 */
export interface JsonApiResource {
  type: string;
  id: string;
  relationships?: Record<
    string,
    {
      data: JsonApiResourceIdentifier | JsonApiResourceIdentifier[] | null;
    }
  >;
}

/**
 * A JSON:API resource identifier.
 */
export interface JsonApiResourceIdentifier {
  type: string;
  id: string;
}

/**
 * A JSON:API document.
 */
export interface JsonApiDocument {
  data?: JsonApiResource | JsonApiResource[] | null;
  included?: JsonApiResource[];
}
